import Keypad from './keypad.view';

export default Keypad;
